import { PASSO_ESCADA_LABEL } from "../../types";
import { dataCurta } from "../../lib/format";
import { DISCIPLINA_CLASSE, type NotaSessao, type Profissional } from "../types";
import { EspecialidadeBadge } from "./EspecialidadeBadge";

/**
 * Timeline interdisciplinar (P0.3 do Elo) — uma criança, todas as disciplinas, uma
 * só linha do tempo, colorida por disciplina (nutri = ardósia). "A tela que ninguém
 * tem": a fono vê o trabalho da TO destravar o seu. Reusa .card; borda por disciplina.
 */
export function TimelineEquipe({
  notas,
  nomePorProfissional,
  onAbrir,
}: {
  notas: NotaSessao[]; // já ordenadas (mais recente primeiro)
  nomePorProfissional: (id: string) => string;
  onAbrir?: (notaId: string) => void;
}) {
  if (notas.length === 0) {
    return (
      <div className="vazio">
        <span className="emoji" aria-hidden>
          🔗
        </span>
        a linha do tempo aparece quando você registrar a 1ª sessão.
      </div>
    );
  }

  return (
    <div className="tl">
      {notas.map((n) => {
        const corpo = (
          <>
            <div className="tl-cab">
              <EspecialidadeBadge especialidade={n.especialidade} curto />
              <span className="tl-quem">{nomePorProfissional(n.profissional_id)}</span>
              <span className="tl-data">{dataCurta(n.data_sessao)}</span>
            </div>
            <div className="tl-obj">{n.objetivo}</div>
            {n.degrau_observado !== null && (
              <div className="tl-degrau">
                resultado: {PASSO_ESCADA_LABEL[n.degrau_observado]}
                {n.degrau_alvo !== null && n.degrau_alvo !== n.degrau_observado
                  ? ` · alvo ${n.degrau_alvo}`
                  : ""}
              </div>
            )}
            {n.orientacoes_casa && (
              <div className="tl-casa">🏠 {n.orientacoes_casa}</div>
            )}
          </>
        );
        const classe = `tl-ev ${DISCIPLINA_CLASSE[n.especialidade]}`;
        return onAbrir ? (
          <button key={n.id} className={`${classe} tl-click`} onClick={() => onAbrir(n.id)}>
            {corpo}
          </button>
        ) : (
          <div key={n.id} className={classe}>
            {corpo}
          </div>
        );
      })}
    </div>
  );
}
